import React from 'react';
import Table from '../Table';
import { bindMethods, stringContains, isNullOrEmpty } from '../../utils/core';
import { SERVICE_VIEWS } from './ServiceConstants';
import { pathOr, merge } from 'ramda';
import Pager from '../Pager';
import SearchInput from '../SearchInput';

const initialState = {
    typesAndActions: [],
    serviceConfig: {},
    pagingArray: [
        {
            page: 1,
            pageSize: 20,
            total: 0,
        },
        {
            page: 1,
            pageSize: 20,
            total: 0,
        },
        {
            page: 1,
            pageSize: 20,
            total: 0,
        },
        {
            page: 1,
            pageSize: 20,
            total: 0,
        },
    ],
    queryArray: [
        '',
        '',
        '',
        '',
    ],
};

export class ServicePreview extends React.Component {

    constructor() {
        super();

        this.state = initialState;

        bindMethods(
            this,
        );
    }

    onSearch(query, index) {
        const queries = this.state.queryArray;
        queries[index] = query;
        const pagings = this.state.pagingArray;
        pagings[index].page = 1;
        this.setState({ queryArray: queries, pagingArray: pagings });
    }

    onPage(pageNumber, index) {
        const pagings = this.state.pagingArray;
        pagings[index] = merge(pagings[index], { page: pageNumber });
        this.setState({ pagingArray: pagings });
    }

    render() {
        const { queryArray, pagingArray } = this.state;

        const doesServiceAlreadyExist = isNullOrEmpty(this.props.currentServiceData) === false;

        const dataArray = [
            doesServiceAlreadyExist ? pathOr([], ['actions'], this.props.currentServiceData) : [],
            doesServiceAlreadyExist ? pathOr([], ['install', 'typeElements'], this.props.currentServiceData) : [],
            this.props.typesAndActions.outputs.find(output => output.developerName === 'Actions').objectData,
            this.props.typesAndActions.outputs.find(output => output.developerName === 'Types').objectData,
        ];

        const columnsArray = [
            [ // Existing Actions
                {
                    renderHeader: () => 'Name',
                    renderCell: ({ item }) => item.developerName,
                },
                {
                    renderHeader: () => 'Uri',
                    renderCell: ({ item }) => item.uriPart,
                },
                {
                    renderHeader: () => 'Summary',
                    renderCell: ({ item }) => item.developerSummary,
                },
            ],
            [ // Existing Types
                {
                    renderHeader: () => 'Name',
                    renderCell: ({ item }) => item.developerName,
                },
                {
                    renderHeader: () => 'Summary',
                    renderCell: ({ item }) => item.developerSummary,
                },
            ],
            [ // New Actions
                {
                    renderHeader: () => 'Name',
                    renderCell: ({ item }) => item.properties.find(property => property.developerName === 'Name').contentValue,
                },
                {
                    renderHeader: () => 'Uri',
                    renderCell: ({ item }) => item.properties.find(property => property.developerName === 'Uri').contentValue,
                },
            ],
            [ // New Types
                {
                    renderHeader: () => 'Name',
                    renderCell: ({ item }) => item.properties.find(property => property.developerName === 'Name').contentValue,
                },
            ],
        ];

        const queriedDataArray = dataArray.map((dataItems, index) => {
            const query = queryArray[index];
            let queriedData = dataItems;

            if (query !== '') {
                queriedData = queriedData.filter(dataItem => columnsArray[index].findIndex(cell => stringContains(
                    cell.renderCell({ item: dataItem }),
                    query,
                    false,
                )) !== -1);
            }

            return queriedData;
        });

        const visibleDataArray = queriedDataArray.map((dataItems, index) => {
            const { page, pageSize } = pagingArray[index];
            const pageStart = pageSize * (page - 1);
            const pageEnd = pageStart + pageSize;

            return dataItems.slice(pageStart, pageEnd);
        });

        const renderSearchableTable = (title, index) => (
            <React.Fragment>
                <h2>
                    {title}
                    <span className="margin-left">
                        {`Total: ${dataArray[index].length}`}
                    </span>
                </h2>
                <div className="flex">
                    <SearchInput onSearch={query => this.onSearch(query, index)} />
                </div>
                <Table
                    className="table margin-top table-striped"
                    columns={columnsArray[index]}
                    items={visibleDataArray[index]}
                />
                <Pager
                    page={pagingArray[index].page}
                    pageSize={pagingArray[index].pageSize}
                    total={queriedDataArray[index].length}
                    onPageClick={page => this.onPage(page, index)}
                />
            </React.Fragment>
        );

        const existingActionsAndTypesSection = doesServiceAlreadyExist ? (
            <div className="flex-grow">
                {renderSearchableTable('Existing Actions', 0)}
                {renderSearchableTable('Existing Types', 1)}
            </div>
        ) : null;

        return (
            <div className="full-height flex-column">
                <div className="admin-page main-scroller">
                    <h2>{`${doesServiceAlreadyExist ? this.props.currentServiceData.developerName : this.props.newServiceData.name} Preview`}</h2>
                    <h2>{doesServiceAlreadyExist ? this.props.currentServiceData.uri : this.props.newServiceData.url}</h2>

                    <div className="flex">
                        {existingActionsAndTypesSection}

                        <div className="flex-grow">
                            {renderSearchableTable(`${doesServiceAlreadyExist ? 'New ' : ''}Actions`, 2)}
                            {renderSearchableTable(`${doesServiceAlreadyExist ? 'New ' : ''}Types`, 3)}
                        </div>
                    </div>
                </div>
                <div className="mw-footer container-fluid">
                    <button
                        type="button"
                        className="btn btn-default outcome"
                        onClick={() => this.props.switchView(SERVICE_VIEWS.ServiceConfiguration)}
                    >
                        {'Back'}
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary outcome"
                        onClick={() => this.props.installService()}
                    >
                        {'Install'}
                    </button>
                </div>
            </div>
        );
    }
}

export default ServicePreview;
